export default "__VITE_ASSET__BMPjS4GI__"